import { Injectable, inject } from "@angular/core";
import { AbstractControl, ValidationErrors } from "@angular/forms";
import { AsyncValidator, registerAsyncValidatorDecorator } from "@recursyve/ngx-form-generator";
import { isDefined } from "@recursyve/nice-ts-utils";
import { Observable, of, timer } from "rxjs";
import { map, switchMap } from "rxjs/operators";

import { ApiService } from "../../../../../../api/api.service";

export function DistributorNameIsUnique(): PropertyDecorator {
    return registerAsyncValidatorDecorator({
        name: "DistributorNameIsUniqueValidator"
    });
}

@Injectable()
export class DistributorNameIsUniqueValidator extends AsyncValidator {
    private readonly apiService = inject(ApiService);

    public readonly name = "DistributorNameIsUniqueValidator";

    public validate(control: AbstractControl): Observable<ValidationErrors | null> {
        const controlValue: unknown = control.value;
        if (!isDefined(controlValue) || typeof controlValue !== "string" || controlValue === "") {
            return of(null);
        }

        return timer(200).pipe(
            switchMap(() =>
                this.apiService.distributors.distributorPropertyExists({ name: controlValue }).pipe(
                    map((isNewDistributorNameValid) => {
                        if (!isNewDistributorNameValid) {
                            control.markAsTouched();
                            return { distributor_name_already_used: true };
                        }

                        return null;
                    })
                )
            )
        );
    }
}
